const nav = [
    {
        name: "Swap",
        name_i18_key: "menu.showdown",
        path: "/swap"
    },
    {
        name: "Pools",
        name_i18_key: "menu.showdown",
        path: "/pools"
    },
    {
        name: "Farms",
        name_i18_key: "menu.showdown",
        path: "/farms"
    },
    {
        name: "Vote",
        name_i18_key: "menu.showdown",
        path: "/vote"
    },
    {
        name: "Charts",
        name_i18_key: "menu.showdown",
        path: "/charts"
    },
]

export default nav